import script from "./CartItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartItem.vue?vue&type=script&lang=ts&setup=true"

import "./CartItem.vue?vue&type=style&index=0&id=746afdec&lang=scss"

const __exports__ = script;

export default __exports__